import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { SidebarProvider } from "./Context/SidebarContext";
import { OrderProvider } from './Context/OrderContext';
import { ToastContainer } from 'react-toastify';
import RootRouters from './Routing';


function App() {
  return (
    <>
      <Router>
        <SidebarProvider>
          <OrderProvider>
            <RootRouters />
          </OrderProvider>
        </SidebarProvider>
      </Router>
      <ToastContainer
        position="top-center"
        theme="colored"
      />
    </>
  );
}

export default App;
